import { ValueOf } from '@shared/types/common.ts';
import { UserCountryCode, UserCountryCodes } from '@shared/types/countryCodes.ts';

export const CountryAssetKeys = {
  DEFAULT: 'default',
  DE: 'de',
} as const;

export type CountryAssetKey = ValueOf<typeof CountryAssetKeys>;

export function resolveCountryAssetKey(countryCode: UserCountryCode | null): CountryAssetKey {
  switch (countryCode) {
    case UserCountryCodes.DE: {
      return CountryAssetKeys.DE;
    }
    default: {
      return CountryAssetKeys.DEFAULT;
    }
  }
}
